import React from 'react';

function WelcomeScreen({ onStart }) {
  return (
    <div style={{
      minHeight: '60vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px'
    }}>
      <div style={{ maxWidth: '1200px', textAlign: 'center' }}>

{/* Big Logo */}


        {/* Feature Badges */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '15px',
          flexWrap: 'wrap',
          marginBottom: '50px'
        }}>
          <div style={{
            padding: '10px 20px',
            backgroundColor: 'rgba(59, 130, 246, 0.2)',
            border: '2px solid #3b82f6',
            borderRadius: '25px',
            color: '#60a5fa',
            fontSize: '19px',
            fontWeight: '600'
          }}>
            📘 ISO/IEC 42001
          </div>

          <div style={{
            padding: '10px 20px',
            backgroundColor: 'rgba(139, 92, 246, 0.2)',
            border: '2px solid #8b5cf6',
            borderRadius: '25px',
            color: '#a78bfa',
            fontSize: '19px',
            fontWeight: '600',
            fontFamily: "'Noto Color Emoji', system-ui, sans-serif"
          }}>
            🇪🇺 EU AI Act
          </div>

          <div style={{
            padding: '10px 20px',
            backgroundColor: 'rgba(6, 182, 212, 0.2)',
            border: '2px solid #06b6d4',
            borderRadius: '25px',
            color: '#22d3ee',
            fontSize: '19px',
            fontWeight: '600'
          }}>
            🏛️ NIST AI RMF
          </div>
        </div>

        {/* Features List */}
        <div style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(10px)',
          padding: '40px',
          borderRadius: '20px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          marginBottom: '40px'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, minmax(200px, 1fr))',
            gap: '30px',
            textAlign: 'left'
          }}>

            <div>
              <div style={{ fontSize: '32px', marginBottom: '10px' }}>📊</div>
              <h3 style={{ color: 'white', marginBottom: '5px', fontSize: '21px' }}>Dashboard</h3>
              <p style={{ color: '#94a3b8', fontSize: '19px', margin: 0 }}>
                Track compliance progress in real-time
              </p>
            </div>

            <div>
              <div style={{ fontSize: '32px', marginBottom: '10px' }}>⚖️</div>
              <h3 style={{ color: 'white', marginBottom: '5px', fontSize: '21px' }}>AI Risk Score</h3>
              <p style={{ color: '#94a3b8', fontSize: '19px', margin: 0 }}>
                AI Risk Score Calculator
              </p>
            </div>

            <div>
              <div style={{ fontSize: '32px', marginBottom: '10px', fontFamily: "'Noto Color Emoji', system-ui, sans-serif" }}>🇪🇺</div>
              <h3 style={{ color: 'white', marginBottom: '5px', fontSize: '21px' }}>EU AI ACT Classifier</h3>
              <p style={{ color: '#94a3b8', fontSize: '19px', margin: 0 }}>
                EU AI Act classification
              </p>
            </div>

            <div>
              <div style={{ fontSize: '32px', marginBottom: '10px' }}>📄</div>
              <h3 style={{ color: 'white', marginBottom: '5px', fontSize: '21px' }}>Document Generator</h3>
              <p style={{ color: '#94a3b8', fontSize: '19px', margin: 0 }}>
                Create policies & assessments automatically
              </p>
            </div>


            <div>
              <div style={{ fontSize: '32px', marginBottom: '10px' }}>🔗</div>
              <h3 style={{ color: 'white', marginBottom: '5px', fontSize: '21px' }}>X-Framework Mapper</h3>
              <p style={{ color: '#94a3b8', fontSize: '19px', margin: 0 }}>
                One step meets all frameworks
              </p>
            </div>

            <div>
              <div style={{ fontSize: '32px', marginBottom: '10px' }}>🤖</div>
              <h3 style={{ color: 'white', marginBottom: '5px', fontSize: '21px' }}>AI Assistant</h3>
              <p style={{ color: '#94a3b8', fontSize: '19px', margin: 0 }}>
                Ask compliance questions, get instant answers
              </p>
            </div>

          </div>
        </div>

        {/* Start Button */}
        <button
          onClick={onStart}
          style={{
            padding: '20px 50px',
            backgroundColor: '#06b6d4',
            color: 'white',
            border: 'none',
            borderRadius: '15px',
            fontSize: '22px',
            fontWeight: 'bold',
            cursor: 'pointer',
            boxShadow: '0 10px 30px rgba(6, 182, 212, 0.4)',
            transition: 'all 0.3s'
          }}
          onMouseOver={(e) => {
            e.target.style.transform = 'scale(1.05)';
            e.target.style.boxShadow = '0 15px 40px rgba(6, 182, 212, 0.6)';
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.boxShadow = '0 10px 30px rgba(6, 182, 212, 0.4)';
          }}
        >
          🚀 Get Started
        </button>

        {/* Bottom Text */}
        <p style={{
          marginTop: '40px',
          color: '#64748b',
          fontSize: '19px'
        }}>
         Secure Your AI, Safeguard Your Future—Quantum-Safe Governance, Risk & Compliance!
        </p>
      </div>
    </div>
  );
}

export default WelcomeScreen;